import { css } from 'lit';

export const headerViewStyles = css`
  .meta-content-wrapper {
    position: relative;
    box-sizing: border-box;
    background-color: var(--metaContentBackgroundColor);
    border-radius: 0;
    margin: 0;
    max-width: 100vw;
    transition: all 0.5s;
  }

  :host(.width600) .meta-content-wrapper {
    margin: 0 20px 20px 20px;
    width: 700px;
    max-width: calc(100vw - 40px);
    border-radius: 12px;
  }

  .header {
    margin: 16px 20px;
    font-weight: 400;
    font-size: 24px;
    color: white;
    z-index: 1;
  }

  d-closer {
    right: -18px;
    width: 30px;
    height: 30px;
  }

  .settings-section {
    margin-bottom: 16px;
    border-radius: 8px;
    background: hsl(195 65% 70%);
    padding: 12px;
  }

  h2 {
    margin-top: 6px;
    margin-bottom: 12px;
    font-size: 20px;
  }

  .content {
    padding: 0 20px 100px 20px;
    overflow-y: auto;
  }

  d-wrap > * {
    margin-bottom: 4px;
    flex-grow: 1;
    flex-shrink: 1;
  }

  d-wrap > *:last-child {
    margin-left: 6px;
  }

  .bottom-right-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }

  .action {
    flex: none;
    display: inline-block;
    appearance: none;
    border: none;
    border-radius: 4px;
    resize: none;
    padding: 10px 14px;
    font-family: var(--mainSans);
    font-size: 15px;
    line-height: normal;
    text-decoration: none;
    cursor: pointer;
    background-color: hsl(197, 82%, 43%);
    font-weight: normal;
    color: white;
  }

  .action[disabled] {
    opacity: 0.5;
    cursor: default;
  }

  @media (hover: hover) {
    .action:not([disabled]):hover {
      background-color: hsl(197, 82%, 33%);
    }
  }
`;
